var XPortal = XPortal || {};
XPortal.Modal = (function () {
    var self = {};

    self.modalSelector = '#modalBox';

    self.init = function (modalSelector) {
        self.setEvents(modalSelector ? modalSelector : self.modalSelector);
        $(document)
            .off('hidden.bs.modal.xstackedfocus')
            .on('hidden.bs.modal.xstackedfocus', '.modal', function () {
                self.restoreFocusForTopModal();
            });
    };

    self.prepareModalFromTemplate = function (templateSelector, disableCloseOnOverlayClick, onDismissCallback, xmodalSelector, xoptions) {
        var $template = templateSelector instanceof jQuery ? templateSelector : $(templateSelector);
        var content = $template.prop('content');
        var $content = content ? $($template.prop('content')) : $template;
        var $html = $content.find('[data-modal-title]');

        var modalParams = [{
            dataset: $.extend({
                showModal: true,
                disableCloseOnOverlayClick: disableCloseOnOverlayClick,
                modalSelector: xmodalSelector ? xmodalSelector : $html.attr('data-modal-selector'),
                modalTitle: $html.attr('data-modal-title'),
                modalText: $template.html(),
                modalType: $html.attr('data-modal-type'),
                modalBackDrop: $html.attr("data-modal-backdrop"),
                modalKeyboard: $html.attr("data-modal-keyboard"),
                modalWidth: $html.attr('data-modal-width'),
                modalHeight: $html.attr('data-modal-height'),
                modalMaxHeight: $html.attr('data-modal-maxheight'),
                modalMinimize: $html.attr('data-modal-minimize'),
                onDismiss: onDismissCallback
            }, xoptions || {})
        }];

        self.checkIfModal(modalParams);
    };

    self.checkIfModal = function (data) {
        var el = $(data)[0];
        if (el && el.dataset && el.dataset.showModal) {
            var $this = cleanUpContainer($(el.dataset.modalSelector ? el.dataset.modalSelector : self.modalSelector));
            var $modalDialog = $this.find('.modal-dialog');
            var $modalBody = $this.find('.modal-body');
            if (el.dataset.modalType) {
                $this.attr('modal-type', el.dataset.modalType);
            } else {
                $this.removeAttr('modal-type');
            }

            if (el.dataset.modalBackDrop) {
                $this.attr('modal-backdrop', el.dataset.modalBackDrop);
            } else {
                $this.removeAttr('modal-backdrop');
            }

            if (el.dataset.modalWidth && el.dataset.modalWidth !== '0') {
                $modalDialog.css('max-width', el.dataset.modalWidth + 'px');
            } else {
                $modalDialog.css('max-width', '');
            }

            if (el.dataset.modalHeight && el.dataset.modalHeight !== '0') {
                const userHeight = parseInt(el.dataset.modalHeight);
                const windowHeight = window.innerHeight;
                const isSpecialModal = $modalDialog.closest('#gridActionsModalBox').length > 0;

                const $target = isSpecialModal ? $modalBody : $modalDialog;

                if (userHeight > windowHeight * 0.8) {
                    $target.css({
                        'height': '85vh',
                        'overflow-y': 'auto'
                    });
                } else {
                    $target.css({
                        'height': userHeight + 'px',
                        'overflow-y': 'auto'
                    });
                }

                if (isSpecialModal) {
                    $modalDialog.css({
                        'height': 'auto',
                        'max-height': '90vh'
                    });
                }
            } else {
                $modalBody.css({ 'height': '' });
            }

            if (el.dataset.modalMaxHeight && el.dataset.modalMaxHeight !== '0') {
                $modalBody.css({ 'max-height': el.dataset.modalMaxHeight + 'px', 'overflow': 'auto' });
                $modalBody.addClass('custom-modal-height');
            } else {
                $modalBody.css({ 'max-height': '' });
            }

            if ((!el.dataset.modalHeight || el.dataset.modalHeight === '0')
                && (!el.dataset.modalMaxHeight || el.dataset.modalMaxHeight === '0')) {
                $modalBody.css({ 'overflow': '' });
            }

            if (el.dataset.modalTitle) {
                $this.find('.modal-header-cnt').html('<h4 class="modal-title">' + $.trim(el.dataset.modalTitle) + '</h4>');
            }
            if (el.dataset.modalMinimize) {
                $this.find('.minimize').removeClass('d-none');
            }

            $this.find('.modal-body').html(el.dataset.modalText ? el.dataset.modalText : el.children);
            var modalOptions = { keyboard: el.dataset.modalKeyboard === 'true' };
            if (el.dataset.disableCloseOnOverlayClick) {
                modalOptions.backdrop = "static";
            }

            if (el.dataset.onDismiss) {
                $this.one("hidden.bs.modal", el.dataset.onDismiss);
            }
            if (el.dataset.onDismissing) {
                $this.off("hide.bs.modal");
                $this.on("hide.bs.modal", el.dataset.onDismissing);
            }
            if (el.dataset.beforeRender) el.dataset.beforeRender($this, el.dataset, modalOptions);
            if (modalOptions.show) {
                $this.off("shown.bs.modal");
                $this.on("shown.bs.modal", function () {
                    if (el.dataset.afterRender) el.dataset.afterRender($this, el.dataset);
                });
            }
            $this.addClass('modal-opened');
            $this.modal(modalOptions);
            if (!modalOptions.show)
                if (el.dataset.afterRender) el.dataset.afterRender($this, el.dataset);
            return true;
        }

        return false;
    };

    self.closeModal = function (data, xmodalSelector) {
        if (data != null) {
            var form = data.closest('form');
            if (form) form.off();
        }

        $(xmodalSelector ? xmodalSelector : self.modalSelector).modal('hide');
    };
    self.hideModal = function (xmodalSelector, onDone) {
        return self.showHideModal(xmodalSelector, onDone, 'hide');
    };
    self.showModal = function (xmodalSelector, onDone) {
        return self.showHideModal(xmodalSelector, onDone, 'show');
    };
    self.showHideModal = function (xmodalSelector, onDone, actionName) {
        var isShowAction = actionName == 'show';
        var eventName = isShowAction ? 'shown.bs.modal' : 'hidden.bs.modal';
        $this = $(xmodalSelector ? xmodalSelector : self.modalSelector);
        $this.off(eventName);
        $this.on(eventName, function () {
            if (onDone) onDone();
        });
        var curState = ($this.data("bs.modal") || {});
        if (curState._isShown == isShowAction || curState._isTransitioning) if (onDone) onDone();
        $this.modal(actionName);
    };

    self.confirm = function (params, onConfirmation, onDismiss) {
        var confirmationParams = params == null ? { options: { headerText: document.title, confirmationText: 'Are you sure?' } } : params;
        var $this = $(self.modalSelector),
            $confirmBlock = $this.find('.confirmation-block');

        $confirmBlock.removeClass('d-none');
        $this.find('.modal-header-cnt').html('<h4 class="modal-title">' + $.trim(confirmationParams.options.headerText) + '</h4>');
        $this.find('.modal-body').html(confirmationParams.options.IsForm ? confirmationParams.options.confirmationText : '<p>' + confirmationParams.options.confirmationText + '</p>');

        if (confirmationParams.options.hasOwnProperty('buttonsText')) {
            if (confirmationParams.options.buttonsText.length > 0) {
                $confirmBlock.find('button').each(function () {
                    $(this).text(confirmationParams.options.buttonsText.splice(0, 1));
                });
            }
        } else {
            $confirmBlock.addClass('d-none');
        }

        $this.on('click', 'button.close', function () {
            self.updateBackdropZIndex(-2);
        });
        $confirmBlock.one('click', 'button[data-action="submit"]', function () {
            confirmationParams.result = 'yes';

            $confirmBlock.addClass('d-none');
            self.closeModal(null, $this);
        }).one('click', 'button[data-action="cancel"]', function () {
            confirmationParams.result = 'no';
            $confirmBlock.addClass('d-none');
            self.updateBackdropZIndex(-2);
            self.closeModal(null, $this);
        });
        $this.off('hidden.bs.modal');
        $this.on('hidden.bs.modal', function (event) {
            self.resetPopupOnClose(event);
            if (onConfirmation) onConfirmation(confirmationParams);
        });

        if (onDismiss) {
            $this.one('click', 'button[data-dismiss="modal"]', function () {
                confirmationParams.result = 'no';
                onDismiss(confirmationParams);
            });
        }

        if (confirmationParams.options.OnInit) {
            confirmationParams.options.OnInit($this);
        }

        if (confirmationParams.options.modalType) {
            $this.attr('modal-type', confirmationParams.options.modalType);
        }

        var modalOptions = { keyboard: false };
        if (confirmationParams.options.disableCloseOnOverlayClick) {
            modalOptions.backdrop = "static";
        }
        $this.modal(modalOptions);
    };

    self.alert = function (params, onConfirmation) {
        var alertParams = params == null ? { headerText: '-', message: '-' } : params;
        self.closeModal();
        setTimeout(function () {
            var $this = $(self.modalSelector);
            if (alertParams.modalType) {
                $this.attr('modal-type', alertParams.modalType);
            }

            $this.find('.alert-block').removeClass('d-none');
            $this.find('.modal-header-cnt').html('<h4 class="modal-title">' + $.trim(alertParams.headerText) + '</h4>');
            $this.find('.modal-body').html('<div>' + alertParams.alertText + '</div>');
            $this.find('.alert-block').one('click', 'button[data-action="cancel"]', function () { $this.find('.alert-block').addClass('d-none'); self.closeModal(); });
            $this.modal({ keyboard: false });
            $this.off('hidden.bs.modal');
            $this.on('hidden.bs.modal', function (event) {
                self.resetPopupOnClose(event);
                if (onConfirmation) onConfirmation();
            });
        }, 250); // why so long delay?
    };

    self.resetPopupOnClose = function (event) {
        var $this = $(event.target);
        $this.off('hidden.bs.modal');
        $this.removeClass('modal-opened');
        $this.removeAttr('modal-type');
        $this.find('.confirmation-block').off().addClass("d-none");
        $this.find('.alert-block').off().addClass("d-none");
        $this.find('.modal-body').empty();
        $this.find('.modal-header-cnt').empty();
        // self.adjustHeaderOnOpenModal(0);
        self.restoreFocusForTopModal();
    };

    self.restoreFocusForTopModal = function () {
        var openModals = $('.modal.show').filter(':visible').toArray();
        if (!openModals.length) {
            $(document).off('focusin.bs.modal');
            return;
        }
        $(document.body).addClass('modal-open');
        var $top = $(openModals.sort(function (a, b) {
            return (parseInt($(a).css('z-index'), 10) || 0) - (parseInt($(b).css('z-index'), 10) || 0);
        }).pop());
        var instance = $top.data('bs.modal');
        if (instance && typeof instance._enforceFocus === 'function') {
            instance._enforceFocus();
        } else {
            $(document).off('focusin.bs.modal');
        }
    };
    self.setEvents = function (selector) {
        $(selector)
            .on('show.bs.modal', function () {
                const scrollHeight = document.documentElement.scrollHeight;
                const clientHeight = document.documentElement.clientHeight;

                const hasScrollbar = scrollHeight > clientHeight + 1;
                
                $('html').toggleClass("prevent-shift", hasScrollbar);
                
                // self.adjustHeaderOnOpenModal(htmlScrollBarWidth);
                const $this = $(this);
                setTimeout(() => {
                    const zIndex = 1040 + 10 * ($(".modal:visible").length + 1);
                    $this.css("z-index", zIndex);
                    self.updateBackdropZIndex();
                }, 1);
            })
            .on('shown.bs.modal', function () {
                var $this = $(this);
                ajaxResponseValidation($this);
                $this.find('form').off('click', 'button[type="button"]').on('click', 'button[type="button"]', function () {
                    self.closeModal($(this).closest('form'));
                });
                XPortal.Main.RecalculateContentElementsSizes($(selector), 200);
                if (XPortal.FEditor) {
                    XPortal.FEditor.InitContentElements(selector);
                }
                XPortal.Main.customThemes(self.modalSelector);
                XPortal.inputHandler.Init($this);

            })
            .on('hide.bs.modal', function () {
                self.updateBackdropZIndex(-2);
                self.BlurFocusedElement();
            })
            .on('hidden.bs.modal', function (event) {
                self.resetPopupOnClose(event);
            });
    };

    self.BlurFocusedElement = function () {
        if (document.activeElement) document.activeElement.blur(); // to prevent focused element in modal to stay focused after close
    };

    self.updateBackdropZIndex = function (incrementor = 0) {
        const $backdrop = $(".modal-backdrop");
        const zIndex = 1040 + 10 * ($(".modal:visible").length + incrementor);
        $backdrop.css("z-index", zIndex);
    }

    self.adjustHeaderOnOpenModal = function (ofsetPx) {
        ofsetPx = parseFloat(ofsetPx);

        let scrollbarWidth = 0;
        let marginForDetailActions = 0;
        const headerWrapper = $('.header-wrapper.fixed');

        const detailActionsWrapper = $('.edit-btns-wrapper.edit-btns-wrapper_header');
        const rightActionsPadding = parseFloat(detailActionsWrapper.css('padding-right'));
        if (ofsetPx) {
            scrollbarWidth = ofsetPx;
            marginForDetailActions = `${rightActionsPadding ? ofsetPx + rightActionsPadding : 0}px`;
            headerWrapper.addClass('no-transition')
        } else {
            scrollbarWidth = parseFloat(document.body.style.paddingRight || 0);
            marginForDetailActions = '';

            setTimeout(() => {
                headerWrapper.removeClass('no-transition');
            }, 1)
        }
        headerWrapper.css('padding-right', `${scrollbarWidth}px`);
        detailActionsWrapper.css('padding-right', marginForDetailActions);
    }

    function cleanUpContainer(icontainer) {
        var container = icontainer ? $(container) : container;
        if (!(container && container.length)) return icontainer;
        var cid = (container).attr("id");
        var copyId = cid + "_ihtml";
        if ($("#" + copyId).length == 0) {
            $("<div class='d-none invisible'/>")
                .attr("id", copyId)
                .html(container.html())
                .appendTo(container.parent());
        } else {
            container.empty().html("").html($("#" + copyId).html());
        }
        return container;
    }
    return self;
}());